import { Office } from './office.model';
import { Client, Project } from './project';

export class Consultant {
  token: string;
  client: Client;
  googleDirectory: GoogleDirectory;
  raas: Raas;
  profilePicture: string;
  permissions: Permission[];
  office: Office;
  projects?: Project[];
}

export class GoogleDirectory {
  kind: string;
  id: string;
  etag: string;
  primaryEmail: string;
  name: any;
  emails: any;
  organizations: any;
  languages: any;
  thumbnailPhotoUrl: string;
  thumbnailPhotoEtag: string;
  customSchemas: any;
}

export class Raas {
  clientId: string;
  department: number;
  aud: string;
  company: string;
  exp: number;
  familyName: string;
  givenName: string;
  iss: string;
  nameid: string;
  nbf: number;
  role: string[];
  sub: string;
  uniqueName: string;
}

export class Permission {
  id: number;
  name: string;
  resources: PermissionResource[];
  nodes: Nodes[];

}

export class PermissionResource {
  actionTypeId: number;
  allowChleck: boolean;
  description: string;
}

export class Nodes {
  id: number;
  name: string;
  resources: PermissionResource[];
}

/**
 *  Las clases tal cual llegan del gestor de permisos
 */
export class OriginalPermission {
  BegDateControllerProccess: Date;
  BegDateDSProccess: Date;
  BegDateQueryProccess: Date;
  ControllerProccessTotalTime: number;
  DSProccessTotalTime: number;
  EndDateControllerProccess: Date;
  EndDateDSProccess: Date;
  EndDateQueryProccess: Date;
  ErrorDynamoDbMessage: string;
  PermissionSource: string;
  QueryProccessTotalTime: number;
  ResourceActions: OriginalPermissionResource[];
  ResourceId: number;
  ResourceName: string;
  ResourceNodes: OriginalPermissionResourceNodes[];
}

export class OriginalPermissionResource {
  ActionTypeId: number;
  AllowChk: boolean;
  Description: string;
}

export class OriginalPermissionResourceNodes {
  ResourceId: number;
  ResourceName: string;
  ResourceActions: OriginalPermissionResource [];
}
